import { render } from "./CatalogueItem.vue?vue&type=template&id=30356e26&scoped=true&bindings={}"
import script from "./CatalogueItem.vue?vue&type=script&lang=ts"
export * from "./CatalogueItem.vue?vue&type=script&lang=ts"

import "./CatalogueItem.vue?vue&type=style&index=0&id=30356e26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30356e26"

export default script